import { useAppStore } from '@/hooks/useAppStore';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const HomePage = () => {
    const user = useAppStore((state) => state.user);
    const navigate = useNavigate();
    useEffect(() => {
        if (user) {
            navigate("/translate");
        } else {
            navigate("/guest-login");
        }
    }, []);

    return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-neutral-900 text-white">
            Logging in..
        </div>
    );
};
